export default {
  DESCRIPTION: 0,
  CREATION: 1,
  FINISHED: 2,
}
